namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PoPurRequestDialog extends Serenity.EntityDialog<PoPurRequestRow, any> {
        protected getFormKey() { return PoPurRequestForm.formKey; }
        protected getIdProperty() { return PoPurRequestRow.idProperty; }
        protected getLocalTextPrefix() { return PoPurRequestRow.localTextPrefix; }
        protected getNameProperty() { return PoPurRequestRow.nameProperty; }
        protected getService() { return PoPurRequestService.baseUrl; }
        protected getDeletePermission() { return PoPurRequestRow.deletePermission; }
        protected getInsertPermission() { return PoPurRequestRow.insertPermission; }
        protected getUpdatePermission() { return PoPurRequestRow.updatePermission; }

        protected form = new PoPurRequestForm(this.idPrefix);
        public potypefg: number;
        public supconsignfg: number;
        public hide: number;
        public paycode: number;

        constructor() {
            super();
            (this.form.DtList.view as any).onDataChanged.subscribe(() => {
                let self = this;
                //ui-state-default slick-footerrow-column l0 r0 frozen
                self.element.find(".ui-state-default.slick-footerrow-column.l0.r0.frozen").html("รวม");
                this.calcDataOnGrid();

            });




            this.form.ShipId.changeSelect2(async e => {
                var x: string = this.form.ShipId.value
                this.form.WhsId.value = null
                if (!Q.isEmptyOrNull(x)) {
                    let a = this.form.ShipId.value
                    let whs: string = Purchase.PoShipAddressRow.getLookup().itemById[a].WhsId;

                    this.form.DtList.whsid = whs
                    console.log(whs)
                    this.form.WhsId.value = whs
                    this.form.DtList.WhsId = whs;

                    this.form.ShipName.value = Purchase.PoShipAddressRow.getLookup().itemById[a].ShipName;
                    this.form.ShipLineAddress1.value = Purchase.PoShipAddressRow.getLookup().itemById[a].ShipLineAddress1;
                    this.form.ShipLineAddress2.value = Purchase.PoShipAddressRow.getLookup().itemById[a].ShipLineAddress2;
                    this.form.ShipLineAddress3.value = Purchase.PoShipAddressRow.getLookup().itemById[a].ShipLineAddress3;

                }
            });

            this.form.SupplierId.changeSelect2(async e => {
                var x: string = this.form.SupplierId.value


                if (!Q.isEmptyOrNull(x)) {
                    // var x :string = this.form.SupplierId.value
                    // console.log( this.form.SupplierId.value+0)
                    let sup = Q.tryFirst(Purchase.PoSupplierRow.getLookup().items, o => o.SupplId == x)
                    // if (sup != null) {
                    this.form.DtList.supid = x
                    this.form.DtList.sup = x
                    this.form.BranchCode.value = sup.BranchCode ?? "";
                    console.log(sup);

                    if (this.potypefg == 1) {
                        let b = sup.ConsignFg ?? 0;
                        let pp = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 37 && x.SysFg > 0)
                        if (b == 1) {
                            this.form.POTypeFg.value = "1";
                            if (pp != null) {
                                this.form.SalesVatTypes.value = "I"
                                this.form.DtList.salevattype = this.form.SalesVatTypes.value
                                this.form.DtList.salevatetype = this.form.SalesVatTypes.value

                                // this.calcVat()
                            }

                        } else {
                            this.form.POTypeFg.value = "0";
                            if (pp != null) {
                                this.form.SalesVatTypes.value = "E"
                                this.form.DtList.salevattype = this.form.SalesVatTypes.value
                                this.form.DtList.salevatetype = this.form.SalesVatTypes.value

                                // this.calcVat()
                            }
                        }
                        console.log(this.form.SalesVatTypes.value)
                        // this.form.DtList.salevatetype = this.form.SalesVatTypes.value

                    }


                    if (this.paycode == 1) {
                        this.form.PayTermCode.value = sup.PayMethod ?? "";
                    }
                    let vatfg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 74 && x.SysFg > 0)
                    if (vatfg != null) {
                        if (sup.PurVatType == "N") {
                            this.form.VatFg.value = "0";
                            this.form.VatCode.value = "N"
                            Serenity.EditorUtils.setReadOnly(this.form.VatCode, true);
                        } else {
                            this.form.VatFg.value = "1";
                            this.form.VatCode.value = sup.PurVatCode ?? "V7";
                        }

                    }

                }
                // }
            });

            this.form.SalesVatTypes.changeSelect2(async e => {
                let vatId = Q.toId(this.form.SalesVatTypes.value)
                if (vatId) {
                    this.form.DtList.salevattype = this.form.SalesVatTypes.value


                }
            });


            this.form.DiscText.change(e => {
                var discStr = Q.toId(this.form.DiscText.value);
                if (!Q.isEmptyOrNull(discStr)) {
                    this.disamtalocate()

                } else {
                    this.form.DtList.DisAlocate = 0;


                    this.dtChange();
                }
            });
            this.form.DiscText.addValidationRule(this.uniqueName, e => {
                var totalAmt = this.form.TotalAmt.value;
                var disAmt = this.form.DiscAmt.value;
                if (totalAmt != null && disAmt != null && disAmt > 0 && disAmt > totalAmt) {
                    return "Discount can't be higher than total amount!";
                }
            });



            this.form.POTypeFg.changeSelect2(e => {
                var x = Q.toId(this.form.POTypeFg.value);
                // if (POTypeFg) {
                // let b =this.form.POTypeFg.value
                // this.form.DtList.Vatchange = POTypeFg
                let pp = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 37 && x.SysFg > 0)
                if (x == "1") {
                    if (pp != null) {
                        this.form.SalesVatTypes.value = "I"
                        this.form.DtList.salevatetype = this.form.SalesVatTypes.value
                    }

                } else {
                    // this.form.POTypeFg.value = "0";
                    if (pp != null) {
                        this.form.SalesVatTypes.value = "E"
                        this.form.DtList.salevatetype = this.form.SalesVatTypes.value

                    }
                }

                this.calcVat()

                // }
            });

            this.form.VatFg.changeSelect2(e => {
                var VatFg = Q.toId(this.form.VatFg.value);
                if (VatFg == 1) {
                    Serenity.EditorUtils.setReadOnly(this.form.VatCode, false);
                    this.form.DtList.Vatchange = this.form.VatCode.value
                    this.dtChange();
                } else {
                    this.form.VatCode.value = "N"
                    Serenity.EditorUtils.setReadOnly(this.form.VatCode, true);
                    this.form.DtList.Vatchange = this.form.VatCode.value
                    this.dtChange();
                }

            });

            this.form.VatCode.changeSelect2(e => {
                var VatCode: string = Q.toId(this.form.VatCode.value);
                if (!Q.isEmptyOrNull(VatCode)) {
                    this.form.DtList.Vatchange = VatCode

                    this.dtChange();

                }
            });





        }
        private dtChange() {
            var totalAmt = 0;
            var VatAmt = 0;

            for (var i of this.form.DtList.getItems()) {
                totalAmt += i.ItemAmt || 0;
                VatAmt += i.ItemVatAmt || 0;

            }
            if (this.form.VatFg.value == "1") {
                var a = this.form.DtList.getItems().map(o => o.VatRate)

                console.log(a)
                console.log(a.length)
                if (a.length > 0) {
                    var b = 0.00
                    b = Math.max.apply(Math, a.map(function (o) { return o; })) || 0                    
                    if(b > 0){
                    var x = Q.first(Administration.CsVatCodeRow.getLookup().items, x => x.VatRate == b);
                    this.form.VatRate.value = x.VatRate
                    this.form.VatCode.value = x.VatCode
                    console.log("change" + b)
                    }else{
                        this.form.VatRate.value = 0;
                        this.form.VatCode.value = "V0"
                    }
                }
            } else {
                this.form.VatRate.value = 0
                this.form.VatCode.value = "N"
            }

            this.form.TotalAmt.value = totalAmt;
            // this.form.DtList.TotalAmt_ = this.form.TotalAmt.value
            if (this.form.VatFg.value == "0") {
                this.form.VatAmt.value = 0;

            } else {
                this.form.VatAmt.value = VatAmt;
            }
            console.log("change" + VatAmt)
            let discamt = this.form.DiscAmt.value;
            let salev = this.form.SalesVatTypes.value

            this.form.NetAmt.value = totalAmt - discamt

            if (totalAmt >= 0) {
                if (salev == 'I') {
                    this.form.PurOrderAmt.value = totalAmt - discamt - VatAmt
                    this.form.NetExVat.value = totalAmt - discamt - VatAmt
                    this.form.NetTotalInVat.value = totalAmt - discamt
                } else {
                    this.form.PurOrderAmt.value = totalAmt - discamt + VatAmt
                    this.form.NetExVat.value = totalAmt - discamt
                    this.form.NetTotalInVat.value = totalAmt - discamt + VatAmt
                }
            }
        }

        private calcDataOnGrid() {
            (this.form.DtList.view as any).onDataChanged.subscribe(() => {
                var totalAmt = 0;
                var VatAmt = 0;

                for (var i of this.form.DtList.getItems()) {
                    totalAmt += i.ItemAmt || 0;
                    VatAmt += i.ItemVatAmt || 0;

                }
                console.log(this.form.VatFg.value)
                if (this.form.VatFg.value == "1") {
                    var a = this.form.DtList.getItems().map(o => o.VatRate)

                    console.log(a)
                    console.log(a.length)
                    if (a.length > 0) {
                        var b = 0.00
                        b = Math.max.apply(Math, a.map(function (o) { return o; })) || 0                    
                        if(b > 0){
                        var x = Q.first(Administration.CsVatCodeRow.getLookup().items, x => x.VatRate == b);
                        this.form.VatRate.value = x.VatRate
                        this.form.VatCode.value = x.VatCode
                        console.log("change" + b)
                        }else{
                            this.form.VatRate.value = 0;
                            this.form.VatCode.value = "V0"
                        }
                    }
                } else {
                    this.form.VatRate.value = 0
                    this.form.VatCode.value = "N"
                }

                this.form.TotalAmt.value = totalAmt;
                this.form.DtList.TotalAmt_ = this.form.TotalAmt.value

                if (this.form.VatFg.value == "0") {
                    this.form.VatAmt.value = 0;
                } else {
                    this.form.VatAmt.value = VatAmt;
                }

                console.log("change" + VatAmt)
                this.calcVat();

            });

            (this.form.DtList.view as any).onRowCountChanged.subscribe(() => {
                var totalAmt = 0;
                var VatAmt = 0;

                for (var i of this.form.DtList.getItems()) {
                    totalAmt += i.ItemAmt || 0;
                    VatAmt += i.ItemVatAmt || 0;

                }

                if (this.form.VatFg.value == "1") {
                    var a = this.form.DtList.getItems().map(o => o.VatRate)

                console.log(a)
                console.log(a.length)
                if (a.length > 0) {
                    var b = 0.00
                    b = Math.max.apply(Math, a.map(function (o) { return o; })) || 0                    
                    if(b > 0){
                    var x = Q.first(Administration.CsVatCodeRow.getLookup().items, x => x.VatRate == b);
                    this.form.VatRate.value = x.VatRate
                    this.form.VatCode.value = x.VatCode
                    console.log("change" + b)
                    }else{
                        this.form.VatRate.value = 0;
                        this.form.VatCode.value = "V0"
                    }
                }
                } else {
                    this.form.VatRate.value = 0
                    this.form.VatCode.value = "N"
                }

                this.form.TotalAmt.value = totalAmt;
                this.form.DtList.TotalAmt_ = this.form.TotalAmt.value
                if (this.form.VatFg.value == "0") {
                    this.form.VatAmt.value = 0;

                } else {
                    this.form.VatAmt.value = VatAmt;
                }
                console.log("countrow" + VatAmt)
                this.calcVat();

            });

        }



        private disamtalocate() {
            //20%,5%,200
            var discStr = this.form.DiscText.value;
            let a = discStr.split(",")



            var totalAmts = this.form.TotalAmt.value;
            var discamt = 0
            //var net = 0

            for (var po of a) {

                if (po.includes("%")) {
                    let a = po.replace("%", "");
                    let b = Number(a);
                    console.log(b)
                    let amt = totalAmts * b / 100
                    discamt = discamt + amt;
                    totalAmts = totalAmts - amt;
                } else {
                    let x = Number(po)
                    discamt = discamt + x
                    totalAmts = totalAmts - x;
                }

            }

            console.log("Lasttotal:" + totalAmts)
            console.log("DiscAmt:" + discamt)

            this.form.DiscAmt.value = discamt

            if (discamt >= 0) {

                this.form.DtList.DisAlocate = discamt;
            }

            this.dtChange();
        }


        private calcVat() {
            let totalAmt = this.form.TotalAmt.value;
            let VatAmt = this.form.VatAmt.value;
            let discamt = this.form.DiscAmt.value;
            let salev = this.form.SalesVatTypes.value

            this.form.NetAmt.value = totalAmt - discamt

            if (totalAmt > 0) {
                console.log(salev)
                if (salev == 'I') {
                    this.form.PurOrderAmt.value = totalAmt - discamt - VatAmt
                    this.form.NetExVat.value = totalAmt - discamt - VatAmt
                    this.form.NetTotalInVat.value = totalAmt - discamt
                } else {
                    this.form.PurOrderAmt.value = totalAmt - discamt + VatAmt
                    this.form.NetExVat.value = totalAmt - discamt
                    this.form.NetTotalInVat.value = totalAmt - discamt + VatAmt
                }
            }

        }

        protected getToolbarButtons(): Serenity.ToolButton[] {

            let buttons = super.getToolbarButtons();

            if (this.isEditMode) {
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "save-and-close-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);
                buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

                let send: Serenity.ToolButton =
                {
                    title: Q.text('Send'),
                    hint: "Send to approve",
                    separator: false,
                    cssClass: "button-sendapp",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        var self = this;


                        this.disamtalocate();

                        if (this.validateForm() && this.validateBeforeSave()) {
                            var options = this.getSaveOptions((response) => {

                                if (this.isEditMode()) {
                                    var id1 = response.EntityId;
                                    if (id1 == null) {
                                        id1 = this.get_entityId();
                                    }
                                    var a = this.loadById(id1);
                                }
                                else {
                                    var a = this.loadById(response.EntityId);
                                }

                                Q.confirm('ยืนยันส่งอนุมัติเอกสาร'
                                    , () => {
                                        this.form.SendForAppfg.value = "1";
                                        var options = this.getSaveOptions((respons2) => {

                                            if (this.isEditMode()) {
                                                var id1 = respons2.EntityId;
                                                if (id1 == null) {
                                                    id1 = this.get_entityId();
                                                }
                                                this.loadById(id1);
                                            }
                                            else {
                                                this.loadById(respons2.EntityId);
                                                // this.dialogClose();
                                            }

                                            this.showSaveSuccessMessage(respons2);


                                        });



                                        options.onError = function (respons2) {
                                            Q.alert(respons2.Error.Message);
                                        }

                                        Q.serviceCall(options);




                                    });


                            });

                            options.onError = function (response) {
                                Q.alert(response.Error.Message);
                            }

                            Q.serviceCall(options);
                        } else {
                            this.save((response) => {
                                this.dialogClose();
                            });


                        }

                    }
                };
                buttons.push(send);

                let newSaveBtn: Serenity.ToolButton =
                {
                    title: "SAVE",
                    hint: "Save",
                    separator: false,
                    cssClass: "button-save",
                    icon: "fa fa-save",
                    hotkey: 'alt+s',
                    onClick: (e) => {

                        var self = this;

                        this.disamtalocate()
                        if (this.validateForm() && this.validateBeforeSave()) {
                            var options = this.getSaveOptions((response) => {

                                if (this.isEditMode()) {
                                    var id1 = response.EntityId;
                                    if (id1 == null) { id1 = this.get_entityId(); }
                                    this.loadById(id1);
                                }
                                else {
                                    if (this.isNew()) {
                                        this.dialogClose();
                                    } else {
                                        this.loadById(response.EntityId);

                                    }
                                }

                                this.showSaveSuccessMessage(response);


                            });

                            options.onError = function (response) {
                                if (response.Error.Message.includes("Can't save record. There is another record")) {
                                    Q.warning(response.Error.Message = "เลขที่เอกสารถูกใช้งานแล้ว ระบบจำทำการบรับเลขที่เอกสาร โปรดทำการบันทึกอีกครั้ง");
                                    var s = self.form.SysDocNo.value
                                    var f = s.substring(0, 9)
                                    GeniuzPOS.Purchase.PoPurRequestService.GetNextNumber({
                                        Prefix: f,
                                        Length: 15
                                    }, response => {

                                        self.form.SysDocNo.value = response.Serial;
                                        this.form.PurDocNo.value = response.Serial;

                                    });
                                } else {
                                    Q.alert(response.Error.Message);
                                }



                            }

                            Q.serviceCall(options);
                        } else {
                            this.save((response) => {
                                this.dialogClose();
                            });


                        }

                    }
                };
                buttons.push(newSaveBtn);



                let newDeleteBtn: Serenity.ToolButton =
                {
                    title: "ลบเอกสาร'",
                    hint: "Delete",
                    separator: false,
                    cssClass: "delete-button",
                    icon: "fa fa-save",
                    hotkey: 'alt+x',
                    onClick: (e) => {
                        Q.confirm('ยืนยันการลบเอกสาร', () => {
                            // this.doDelete(() => {

                            //     this.dialogClose();
                            // });
                            this.form.CancelFg.value = "1";
                            this.save((response) => {
                                this.dialogClose();
                            });

                        });
                    }
                };
                buttons.push(newDeleteBtn);


            }
            let Editaddress: Serenity.ToolButton =
            {
                title: "Hide/Show address'",
                hint: "Edit address",
                separator: false,
                cssClass: "bt-editaddress",
                // icon: "fa fa-save",
                // hotkey: 'alt+x',
                onClick: (e) => {
                    if (this.hide == 1) {
                        this.hideadd(0);
                    } else {
                        this.hideadd(1);
                    }

                }
            };
            buttons.push(Editaddress);



            buttons.push(
                {
                    title: Q.text("Close"),	// *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    hint: 'esc',
                    hotkey: 'esc',
                    onClick: () => {
                        this.dialogClose();

                    },
                }
            );


            let realocate: Serenity.ToolButton =
            {
                title: "",
                hint: "recall",
                separator: false,
                cssClass: "recall",
                icon: "fa fa-undo-alt",

                onClick: (e) => {
                    this.disamtalocate()
                }
            };
            buttons.push(realocate);

            let revat: Serenity.ToolButton =
            {
                title: "",
                hint: "revat",
                separator: false,
                cssClass: "revat",
                icon: "fa fa-undo-alt",

                onClick: (e) => {
                    this.form.DtList.Vatchange = this.form.VatCode.value
                    this.calcVat()
                }
            };
            // buttons.push(revat);



            return buttons;


        }

        private hideadd(hided: number) {
            if (hided == 1) {
                this.form.ShipLineAddress1.getGridField().toggle(false);
                this.form.ShipLineAddress2.getGridField().toggle(false);
                this.form.ShipLineAddress3.getGridField().toggle(false);
                this.hide = 1
            } else {
                this.form.ShipLineAddress1.getGridField().toggle(true);
                this.form.ShipLineAddress2.getGridField().toggle(true);
                this.form.ShipLineAddress3.getGridField().toggle(true);
                this.hide = 0
            }
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.syscuscheck();
            this.form.DtList._appfg = true
            this.form.DtList.myPassValue = this.form.SysDocNo.value
            this.form.DtList.supid = this.form.SupplierId.value
            this.form.DtList.whsid = this.form.WhsId.value
            this.form.DtList.salevattype = this.form.SalesVatTypes.value


            this.hideadd(1);



            if (this.isNew()) {
                var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
                console.log('User Id : ' + userId.ShopId);
                this.form.ShopId.value = userId.ShopId
                this.form.DtList.shopid = userId.ShopId
                this.getNextNumber();
                this.toolbar.findButton('button-sendapp').hide();
                this.toolbar.findButton('delete-button').hide();

                // console.log(this.form.DtList._appfg+"hd")

            } else {
                if (this.entity.ApproveFg == 1 || this.entity.ApproveFg == 2 || this.entity.CancelFg == 1) {
                    this.toolbar.findButton('delete-button').hide();
                    this.toolbar.findButton('button-sendapp').hide();
                    this.toolbar.findButton('button-save').hide();
                    this.toolbar.findButton('apply-changes-button').toggleClass('disabled', false);
                    this.toolbar.findButton('bt-approve').hide();
                    this.toolbar.findButton('bt-reject').hide();
                    this.toolbar.findButton('bt-Return').hide();
                    this.form.DtList._appfg = false
                    this.form.DtList.set_readOnly(true);
                    this.appreadonly();


                } if (this.entity.SendForAppfg == 1) {
                    // this.form.DtList.Appfg = true
                    this.toolbar.findButton('delete-button').hide();
                    this.toolbar.findButton('button-sendapp').hide();
                    this.toolbar.findButton('button-save').hide();
                    this.toolbar.findButton('apply-changes-button').toggleClass('disabled', false);
                    this.form.DtList.set_readOnly(true);
                    this.form.DtList._appfg = false
                    this.appreadonly();

                } else {
                    // this.form.DtList.Appfg = false
                    this.dtChange();


                }
            }
            this.toolbar.findButton('recall').insertAfter(this.form.DiscText.element)
            this.toolbar.findButton('revat').insertAfter(this.form.VatCode.element)



            ////----
            let self = this;
            let nbrRetry = 0;
            (function changeTitle() {
                if (nbrRetry >= 10) {
                    return;
                }

                setTimeout(() => {
                    if ((self as any).isMarkedAsPanel === true) {
                        if (self.element.find(".panel-titlebar").length == 1) {
                            // self.element.find(".panel-titlebar").html("");
                            //self.element.find(".panel-titlebar-text").html("");
                            self.element.find(".panel-titlebar-close").html("");//panel-titlebar
                        }
                        else {
                            changeTitle();
                        }
                    }
                    else {
                        if (self.element.parent().find(".panel-titlebar").length == 1) {
                            // self.element.parent().find(".panel-titlebar").html("");
                            // self.element.parent().find(".panel-titlebar-text").html("");
                            self.element.parent().find(".panel-titlebar-close").html("");
                        }
                        else {
                            changeTitle();
                        }
                    }
                }, 100);
            })();


        }
        private syscuscheck() {
            let app = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 3 && x.SysFg > 0)
            console.log(app)
            if (app != null) {
                this.form.SalesVatTypes.getGridField().toggle(true);
            } else {
                this.form.SalesVatTypes.getGridField().toggle(false);
            }

            let vatfg = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 64 && x.SysFg > 0)
            console.log(vatfg)
            if (vatfg != null) {
                this.form.VatFg.getGridField().toggle(true);
            } else {
                this.form.VatFg.getGridField().toggle(false);
            }
            let potype = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 67 && x.SysFg > 0)

            if (potype != null) {
                this.potypefg = 1;
                this.form.POTypeFg.getGridField().toggle(true);
            } else {
                this.potypefg = 0;
                this.form.POTypeFg.getGridField().toggle(false);
            }
            let docdate = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 26 && x.SysFg > 0)
            // console.log(vatfg)
            if (docdate != null) {
                Serenity.EditorUtils.setReadOnly(this.form.DocDate, true);
            } else {

            }
            let pay = Q.tryFirst(Lookups.SysParaRow.getLookup().items, x => x.Id == 29 && x.SysFg > 0)

            if (pay != null) {
                this.paycode = 1;
            } else {
                this.paycode = 0;
            }

        }

        protected getSaveEntity(): PoPurRequestRow {
            let entity = super.getSaveEntity();

            return entity;
        }

        // protected validateBeforeSave(): boolean {
        //     super.validateBeforeSave();

        //     return this.validateBeforeSave();
        // }
        private getNextNumber() {
            var val = Q.trimToNull(this.form.SysDocNo.value);



            if (!val || val.length <= 3) {
                var someDate = new Date();
                var dd = someDate.getDate();
                var mm = someDate.getMonth() + 1;
                var myRow = 0;
                var userId = Q.first(Administration.UserRow.getLookup().items, x => x.ShopId == Authorization.userDefinition.ShopId);
                console.log('User Id : ' + userId.ShopId);
                // this.form.ShopId.value = userId.ShopId
                // this.form.DtList.shopid = userId.ShopId
                try {
                    var userRole = Q.first(Administration.UserRoleRow.getLookup().items, x => x.UserId == userId.UserId);

                    if (userRole != null) {
                        myRow = userRole.RoleId;
                    }
                    if (userRole != null || userRole.RoleId.valueOf) {
                        myRow = userRole.RoleId;
                    }
                    if (myRow == 1) {
                        //(this.form.SlmnCode.element as any).select2(userId.SlmnCode);
                    }
                } catch {

                }

                var y = someDate.getFullYear();
                var mo = "";
                var ddd = "";

                if (mm < 10) {
                    mo = '0' + mm;

                } else {
                    mo = mm.toString();
                }

                if (dd < 10) {
                    //ddd = '0' + dd;
                    ddd = '';

                } else {
                    //ddd = dd.toString();
                    ddd = '';
                }

                var someFormattedDate = y.toString().substr(2, 2);

                var docprefix = Q.tryFirst(Product.CsDocTypeRow.getLookup().items, x => x.DocType == "15").DocPrefix;
                var prefix = docprefix + userId.ShopId + someFormattedDate + mo + ddd;
                GeniuzPOS.Purchase.PoPurRequestService.GetNextNumber({
                    Prefix: prefix,
                    Length: 15
                }, response => {

                    this.form.SysDocNo.value = response.Serial;
                    this.form.PurDocNo.value = response.Serial;
                    // this.form.DocDate.element.focus();
                });
            }

        }

        private appreadonly() {
            // this.form.PurDocNo.set_readOnly(true);
            Serenity.EditorUtils.setReadOnly(this.form.DocNo, true);
            Serenity.EditorUtils.setReadOnly(this.form.DocDate, true);
            Serenity.EditorUtils.setReadOnly(this.form.SupplierId, true);
            Serenity.EditorUtils.setReadOnly(this.form.RefDocNo1, true);
            Serenity.EditorUtils.setReadOnly(this.form.RefDocNo2, true);
            Serenity.EditorUtils.setReadOnly(this.form.ShipId, true);
            Serenity.EditorUtils.setReadOnly(this.form.PayTermCode, true);
            Serenity.EditorUtils.setReadOnly(this.form.VatFg, true);
            Serenity.EditorUtils.setReadOnly(this.form.POTypeFg, true);
            Serenity.EditorUtils.setReadOnly(this.form.SalesVatTypes, true);
            Serenity.EditorUtils.setReadOnly(this.form.ShipDate, true);

            Serenity.EditorUtils.setReadOnly(this.form.Remark, true);
            Serenity.EditorUtils.setReadOnly(this.form.DiscText, true);
            Serenity.EditorUtils.setReadOnly(this.form.VatCode, true);

            Serenity.EditorUtils.setReadOnly(this.form.ShipLineAddress1, true);
            Serenity.EditorUtils.setReadOnly(this.form.ShipLineAddress2, true);
            Serenity.EditorUtils.setReadOnly(this.form.ShipLineAddress3, true);
            Serenity.EditorUtils.setReadOnly(this.form.DtList, true);
            
        }

        

    }
}